import { RefObject, useEffect, useState } from "react";

const useIntersectionObserver = (ref: RefObject<any>, threshold = 0): {
  isInView: boolean;
  hasAlreadyRendered: boolean;
  countRendered: number;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
} => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [hasAlreadyRendered, setHasAlreadyRendered] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState<number>(1);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
        if (entry.isIntersecting && !hasAlreadyRendered) {
          if (count > 1) setHasAlreadyRendered(true);
          else setCount((prevCount) => ++prevCount);
        }
      },
      { threshold }
    );

    const element = ref.current;
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [threshold, hasAlreadyRendered, count]);

  return { isInView: isIntersecting, hasAlreadyRendered, countRendered: count, page, setPage };
};

export default useIntersectionObserver;